/**
 * Anniversary Giveaway Section - Splide Slider Controller
 */
(function () {
  'use strict';

  function initAnniversarySplide(sliderEl) {
    if (!sliderEl) return;

    // Destroy existing instance if already mounted (e.g. on Shopify theme editor reloads)
    if (sliderEl.splideInstance) {
      try {
        sliderEl.splideInstance.destroy(true);
      } catch (e) {}
    }

    // Wait if Splide library is deferred and not yet available
    if (typeof Splide === 'undefined') {
      setTimeout(function () {
        initAnniversarySplide(sliderEl);
      }, 60);
      return;
    }

    var isLoop = sliderEl.getAttribute('data-loop') === 'true';
    var perPageDesktop = parseInt(sliderEl.getAttribute('data-per-page-desktop'), 10) || 5;
    var slideGap = parseInt(sliderEl.getAttribute('data-slide-gap'), 10) || 16;
    var isAutoplay = sliderEl.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(sliderEl.getAttribute('data-interval'), 10) || 4000;
    var pauseOnHover = sliderEl.getAttribute('data-pause-on-hover') === 'true';

    var splide = new Splide(sliderEl, {
      type: isLoop ? 'loop' : 'slide',
      perPage: perPageDesktop,
      focus: 'center',
      padding: { left: '8.8%', right: '8.8%' },
      gap: slideGap + 'px',
      arrows: false,
      pagination: false,
      autoplay: isAutoplay,
      interval: interval,
      pauseOnHover: pauseOnHover,
      pauseOnFocus: true,
      drag: true,
      breakpoints: {
        1200: {
          perPage: perPageDesktop,
          focus: 'center',
          padding: { left: '8.8%', right: '8.8%' },
          gap: '14px'
        },
        1024: {
          perPage: 3,
          focus: 'center',
          padding: { left: '12%', right: '12%' },
          gap: '14px'
        },
        767: {
          perPage: 1,
          focus: 'center',
          padding: { left: '21%', right: '21%' },
          gap: '12px',
          arrows: false,
          pagination: false
        },
        480: {
          perPage: 1,
          focus: 'center',
          padding: { left: '20%', right: '20%' },
          gap: '12px',
          arrows: false,
          pagination: false
        },
        380: {
          perPage: 1,
          focus: 'center',
          padding: { left: '17%', right: '17%' },
          gap: '10px',
          arrows: false,
          pagination: false
        }
      }
    });

    splide.mount();
    sliderEl.splideInstance = splide;
  }

  function initAllSliders(container) {
    var root = container || document;
    var sliders = root.querySelectorAll('.anniversary-splide');
    sliders.forEach(function (slider) {
      initAnniversarySplide(slider);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSliders();
    });
  } else {
    initAllSliders();
  }

  // Shopify Theme Customizer section events
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      initAllSliders(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target) {
      var sliders = e.target.querySelectorAll('.anniversary-splide');
      sliders.forEach(function (slider) {
        if (slider.splideInstance) {
          try {
            slider.splideInstance.destroy(true);
          } catch (err) {}
        }
      });
    }
  });
})();
